interface PopoverTourStepConfig {
  placement: 'bottom' | 'bottom-start' | 'bottom-end'
}

export const POPOVER_TOUR_STEPS: PopoverTourStepConfig[] = [
  { placement: 'bottom-end' },
  { placement: 'bottom-start' },
  { placement: 'bottom-end' },
]
